import { UsersWaivers } from './UsersWaivers'
export default UsersWaivers